import {Component, OnInit, ViewChild} from '@angular/core';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {PoamItem, Project, User} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import {IndexConfigService} from "../../_services/index.config.service";
import {ActionPlan} from "../../_models/actionPlan";
import {FormBuilder, Validators} from "@angular/forms";
import {SelectProjectControlItemComponent} from "../selectProjectControlItem/select-project-control-item.component";
import {
  SelectSingleProjectControlItemComponent
} from "../selectSingleProjectControlItem/select-single-project-control-item.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { DictionaryService } from "../../_services/dictionary.service";
import { AppTextResourcesService } from '../../_services/app.text.resources.service';
import {AddSignatureComponent} from "../addSignature/addSignature.component";

@Component({
    standalone: false,
  selector: "poam-list-component",
  templateUrl: 'global-poam-list.component.html',
  styleUrls: ['./global-poam-list.component.scss'],
})

export class GlobalPoamListComponent implements OnInit {
  actionPlans: any[] = [];
  currentUser: User;
  tenantName: string;
  isSaving = false;
  topics: string[];
  cols: any[] = [
    {'field': 'projectName', 'header': 'Project'},
    {'field': 'topic', 'header': 'Topic'},
    {'field': 'name', 'header': 'Name'},
    {'field': 'source', 'header': 'Source'},
    {'field': 'riskLevel', 'header': 'Risk'},
    {'field': 'system', 'header': 'System'},
    {'field': 'responsibleParty', 'header': 'Owner'},
    {'field': 'currentStatusValue', 'header': 'Status'},
    {'field': 'createdDate', 'header': 'Created'},
    {'field': 'dueDate', 'header': 'Due Date'},
  ]
  lowMediumHigh = {0: 'Low', 1: 'Medium', 2: 'High'};

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public config: IndexConfigService,
    public authenticationService: AuthenticationService,
    public dictionaryService: DictionaryService,
    public dialog: MatDialog,
    public clientProfileService: ClientProfileService,
    private constants: AppTextResourcesService) {

  }

  ngOnInit() {

    const tenantName = this.tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.dictionaryService.get(['Topic']).subscribe(p => this.topics = p.map(i => i.name));

    this.loadProjectControlItems();
  }

  public loadProjectControlItems(showLoading = true, savedItem = null) {

    const year = new Date(Date.now()).getFullYear();
    (showLoading ? this.projectService.getForPoamGlobal : this.projectService.getForPoamGlobalNoLoading).bind(this.projectService)()
      .subscribe(projectControlItems => {
          projectControlItems = projectControlItems.filter(x => x.actionPlans != null && x.actionPlans.length > 0);

          this.actionPlans = [];
          projectControlItems.forEach(projectControlItem => {
            projectControlItem.actionPlans.forEach(actionItem => {
              const actionPlan = {
                projectControlItemId: projectControlItem.projectControlItemId,
                actionPlanId: actionItem.actionPlanId,
                category: projectControlItem.controlItem.category,
                topic: actionItem.topic,
                loe: actionItem.loe,
                requirementOrGuidance: actionItem.requirementOrGuidance,
                affectedSystems: actionItem.affectedSystems,
                source: actionItem.source,
                system: actionItem.system,
                createdDate: actionItem.createdDate,
                area: projectControlItem.controlItem.complianceAreaName,
                complianceAreaControlId: projectControlItem.controlItem.complianceAreaControlId,
                currentStatusValue: {
                  0: "Not Started",
                  1: "In-Progress",
                  2: "Resolved",
                  3: "Awaiting Review",
                  4: "Reviewed - Not POAM"
                }[actionItem.currentStatus],
                name: actionItem.name,
                weaknessDescription: actionItem.weaknessDescription,
                remediationPlansActionsMilestones: actionItem.remediationPlansActionsMilestones,
                responsibleParty: actionItem.responsibleParty,
                riskLevel: actionItem.riskLevel,
                form: null,
                projectName: projectControlItem.projectName,
                signedName: actionItem.signedName,
                signedDate: actionItem.signedDate
              };
              const formGroup = this.getForm(actionItem);
              actionPlan.form = formGroup;
              this.actionPlans.push(actionPlan);
            })
          });
        },

        error => {
          const errorMessage = 'An error occurred while loading projects.';
          this.alertService.error(errorMessage);
        });
  }

  getForm(actionItem) {
    return this.formBuilder.group({
      name: [actionItem.name, [Validators.required]],
      weaknessDescription: [actionItem.weaknessDescription, [Validators.required]],
      howIdentified: [actionItem.howIdentified, [Validators.required]],
      responsibleParty: [actionItem.responsibleParty, [Validators.required]],
      identificationDate: [actionItem.identificationDate, [Validators.required]],
      currentStatus: [actionItem.currentStatus, [Validators.required]],
      scheduledCompletionDate: [actionItem.scheduledCompletionDate, [Validators.required]],
      actualCompletionDate: [actionItem.actualCompletionDate],
      remediationPlansActionsMilestones: [actionItem.remediationPlansActionsMilestones, [Validators.required]],
      changesToRemediationPlansActionsMilestones: [actionItem.changesToRemediationPlansActionsMilestones],
      comments: [actionItem.comments],
      typeBool: [actionItem.type === 1],
      riskLevel: [actionItem.riskLevel],
      topic: [actionItem.topic],
      loe: [actionItem.loe],
      requirementOrGuidance: [actionItem.requirementOrGuidance],
      affectedSystems: [actionItem.affectedSystems],
      source: [actionItem.source],
      system: [actionItem.system],
      signedName: [actionItem.signedName],
      signedDate: [actionItem.signedDate]
    });
  }

  save(item) {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    var poam = {
      actionPlanId: item.actionPlanId < 0 ? 0 : item.actionPlanId,
      projectId: item.projectId,
      projectControlItemId: item.projectControlItemId,
      controlItem: {
        category: item.category,
        complianceAreaName: item.area,
        complianceAreaControlId: item.complianceAreaControlId
      },
      currentStatus: {
        "Not Started": 0,
        "In-Progress": 1,
        "Resolved": 2,
        "Awaiting Review": 3,
        "Reviewed - Not POAM": 4
      }[item.currentStatus],
      name: item.name,
      topic: item.topic,
      loe: item.loe,
      requirementOrGuidance: item.requirementOrGuidance,
      affectedSystems: item.affectedSystems,
      weaknessDescription: item.weaknessDescription,
      remediationPlansActionsMilestones: item.remediationPlansActionsMilestones,
      riskLevel: item.riskLevel,
      ...item.form.value,
      type: item.form.typeBool ? 1 : 0,
    }
    this.projectService.savePoam(poam).subscribe((r) => {
      this.isSaving = false;
      if (!r[0].projectControlItem) {
        this.alertService.error('Project Control Item not found');
      } else {
        item.actionPlanId = r[0].actionPlan.actionPlanId;
        item.category = r[0].projectControlItem.controlItem.category;
        item.area = r[0].projectControlItem.controlItem.complianceAreaName;
      }
      this.loadProjectControlItems();
    }, e => {
      this.isSaving = false;
      this.alertService.error('Project Control Item not found');
    });
  }

  addActionPlan() {
    this.actionPlans = [{form: this.getForm({})}, ...this.actionPlans];
  }

  selectProjectControlItem(item) {
    var config: MatDialogConfig = {
      width: '70%',
      data: {
        projectId: item.projectId
      }
    };
    const controlsDialogRef = this.dialog.open(
      SelectSingleProjectControlItemComponent, config
    );

    controlsDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        item.projectControlItemId = data.projectControlItemId;
        item.complianceAreaControlId = data.controlItem.complianceAreaControlId;
      }
    });
  }
  sign(item) {
    let config: MatDialogConfig = {
      data: {
      }
    };

    let dialogRef = this.dialog.open(AddSignatureComponent, config);

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        item.form.patchValue({signedName: data.name, signedDate: data.date});
      }
    });
  }
}
